import { ItemDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/item_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type ItemDeletedDetailProps = {
  event: ItemDeletedEvent;
};

export const ItemDeletedDetail = ({ event }: ItemDeletedDetailProps) => {
  const item = event.item;

  if (!item) {
    return (
      <Col className="@ItemDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@ItemDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Item
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={item.id?.value} />
          <FieldDisplay label="Name" value={item.name} />
          <FieldDisplay label="SKU Number" value={item.skuNumber} />
          <IDField label="Category ID" value={item.categoryId?.value} />
          <IDField label="Item Group ID" value={item.itemGroupId?.value} />
          <FieldDisplay label="Description" value={item.description} />
        </div>
      </Col>
    </Col>
  );
};
